import { cn as e } from "../../lib/utils.es.js";
import { Button as t } from "../ui/button.es.js";
import { Input as n } from "../ui/input.es.js";
import { UserAvatar as r } from "../UserAvatar/UserAvatar.es.js";
import { DataTableColumnHeader as i } from "./DataTableColumnHeader.es.js";
import { useId as a } from "react";
import { ChevronDown as o } from "lucide-react";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
// libs/ui-lib/src/components/DataTable/DataTableParts.tsx
var u = "flex h-10 items-center bg-muted px-4 text-left font-medium text-foreground text-sm leading-5", d = "inline-flex items-center rounded-full bg-secondary px-2 py-0.5 font-medium text-foreground text-xs";
function f({ column: t, title: n, children: r, className: a, ...o }) {
	return /* @__PURE__ */ c("div", {
		className: e(u, a),
		...o,
		children: t && n ? /* @__PURE__ */ c(i, {
			column: t,
			title: n
		}) : r ?? n
	});
}
function p({ table: e, title: n }) {
	return /* @__PURE__ */ c(t, {
		type: "button",
		variant: "ghost",
		size: "sm",
		className: "h-auto justify-start rounded-none px-0 py-0 font-medium text-foreground text-sm leading-5 hover:bg-transparent hover:text-foreground",
		onClick: () => e.resetSorting(),
		children: /* @__PURE__ */ c("span", { children: n })
	});
}
function m({ children: t, className: n, flex: r = !1, muted: i = !1, numeric: a = !1, ...o }) {
	return /* @__PURE__ */ c("div", {
		className: e(r ? "flex min-w-0 items-center px-4" : "px-4", i ? "text-muted-foreground" : "text-foreground", "text-sm", a && "tabular-nums", n),
		...o,
		children: t
	});
}
function h({ children: t, className: n, ...r }) {
	return /* @__PURE__ */ c("div", {
		className: e("flex justify-end px-4", n),
		...r,
		children: t
	});
}
function g({ children: t, className: n, muted: r = !1, ...i }) {
	return /* @__PURE__ */ c("span", {
		className: e(d, r && "text-muted-foreground", n),
		...i,
		children: t
	});
}
function _({ name: t, email: n, seed: i, meta: a, className: o, ...s }) {
	return /* @__PURE__ */ l("div", {
		className: e("flex min-w-0 items-center gap-2", o),
		...s,
		children: [/* @__PURE__ */ c(r, {
			name: t,
			email: n,
			seed: i,
			size: "sm"
		}), a ? /* @__PURE__ */ c("span", {
			className: "min-w-0 truncate text-foreground text-sm tabular-nums",
			children: a
		}) : null]
	});
}
function v({ value: t, onClick: n, ariaLabel: r, icon: i, className: a, ...o }) {
	let u = t === 0 ? /* @__PURE__ */ c("span", {
		className: "text-muted-foreground",
		children: "—"
	}) : /* @__PURE__ */ l(s, { children: [i, /* @__PURE__ */ c("span", { children: t })] }), d = t > 0 && !!n;
	return /* @__PURE__ */ c(m, {
		numeric: !0,
		className: e("flex items-center justify-center gap-1.5", a),
		...o,
		children: d ? /* @__PURE__ */ c("button", {
			type: "button",
			onClick: n,
			"aria-label": r,
			className: "inline-flex items-center gap-1.5 font-medium text-foreground text-sm tabular-nums hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40",
			children: u
		}) : u
	});
}
function y({ expanded: n, onToggle: r, label: i, className: a }) {
	return /* @__PURE__ */ c(t, {
		type: "button",
		variant: "ghost",
		size: "sm",
		"aria-expanded": n,
		"aria-label": i ?? (n ? "Collapse row" : "Expand row"),
		onClick: r,
		className: e("size-7 rounded-md p-0 text-muted-foreground hover:bg-muted hover:text-foreground", a),
		children: /* @__PURE__ */ c(o, {
			className: e("size-4 transition-transform", n && "rotate-180"),
			"aria-hidden": "true"
		})
	});
}
function b({ editing: t, value: r, onChange: i, onSubmit: o, error: s, ariaLabel: u, className: d }) {
	let f = a();
	return t ? /* @__PURE__ */ l(m, {
		className: e("py-1", d),
		children: [/* @__PURE__ */ c(n, {
			value: r,
			"aria-label": u,
			"aria-invalid": s ? !0 : void 0,
			"aria-describedby": s ? f : void 0,
			onChange: (e) => i(e.target.value),
			onKeyDown: (e) => {
				e.key === "Enter" && !e.nativeEvent.isComposing && o?.();
			}
		}), s ? /* @__PURE__ */ c("p", {
			id: f,
			className: "mt-1 text-destructive text-xs",
			children: s
		}) : null]
	}) : /* @__PURE__ */ c(m, {
		flex: !0,
		className: e("h-11", d),
		children: r || "-"
	});
}
export { h as DataTableActionsCell, m as DataTableCellContent, v as DataTableCountCell, b as DataTableEditableCell, y as DataTableExpandToggle, f as DataTableHeaderCell, g as DataTablePill, p as DataTableResetSortHeader, _ as DataTableUserCell, u as dataTableHeaderCellClass, d as dataTablePillClass };
